<div class="viewport">
  <ig-loader size="parentSize" *ngIf="loading"></ig-loader>

  <div class="app-header">
    <a href="" class="logo">
      <img class="medium-up" src="assets/img/theme/logo_2x.png" alt="gridscale Logo">
      <img class="small" src="assets/img/theme/logo_small_2x.png" alt="gridscale Logo">
    </a>
  </div>


  <div class="stage">
    <div class="message-container">
      <div class="message" [ngClass]="{'error': error, 'success': success, 'visible': error || success}">
        <div class="icon-container">
          <i *ngIf="success" class="fas fa-check-circle"></i>
          <i *ngIf="error" class="fas fa-times"></i>
        </div>

        <div *ngIf="error" class="message-content">{{errorMessage}}</div>
        <div *ngIf="success" class="message-content">{{'sca_success_message' | translate}}</div>
      </div>
    </div>
  </div>
</div>
